import { useEffect, useRef, useState } from 'react';
import { useApi } from '../../hooks/useApi';
export function useRouteSave() {
  const { fetchApi, error } = useApi();
  const alive = useRef(true); const inFlight = useRef(false);
  const attempt = useRef<{ path: string; method: string; body: string } | null>(null);
  const [saving, setSaving] = useState(false); const [locked, setLocked] = useState(false);
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);
  const save = async (path: string, method: string, body: Record<string, unknown>) => {
    if (inFlight.current) return null;
    inFlight.current = true; setSaving(true); setLocked(true);
    attempt.current ||= { path, method, body: JSON.stringify({ ...body, request_id: crypto.randomUUID() }) };
    const result = await fetchApi<{ success: boolean; id: number }>(attempt.current.path, { method: attempt.current.method, body: attempt.current.body });
    inFlight.current = false;
    if (!alive.current) return null;
    setSaving(false);
    if (result?.success) { attempt.current = null; setLocked(false); }
    return result;
  };
  const reset = () => { if (!inFlight.current) { attempt.current = null; setLocked(false); } };
  return { save, reset, saving, locked, error: locked ? error : null };
}
export function localRouteDate() {
  const now = new Date(); return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}
